import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SettingsService } from '../../../pages/settings/settings.service';
import { TicketDialogService } from '../ticket-dialog/ticket-dialog.service';

import * as moment from 'moment';

@Component({
  selector: 'app-ticket-dialog',
  templateUrl: './ticket-dialog.component.html',
  styleUrls: ['./ticket-dialog.component.scss'],
  providers: [ SettingsService, TicketDialogService ]
})
export class TicketDialogComponent implements OnInit{

  public ticket: any;
  public btn_disabled: boolean;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
    Validators.min(1)
  ]);

  approved: boolean;
  business_id: number;

  constructor(
            public settingsService: SettingsService,
            public dialogRef: MatDialogRef<TicketDialogComponent>,
            @Inject(MAT_DIALOG_DATA) public data: any,
            public fb: FormBuilder,
            private toastr: ToastrService,
            public ticketDialogService: TicketDialogService
        ) {
          
          //console.log(data);
          this.ticket = data;
          this.business_id = data.business_id;
          this.approved = data.status == 'APROBADA' ? true: false;
          if(this.ticket.email && this.approved){
            this.sendMail(this.ticket.email);
            this.applyPayment(this.ticket.transaction);
          }

          this.btn_disabled = true;
  }

  ngOnInit(){
  }

  applyPayment(transaction){
    this.ticketDialogService.applyPayment({transaction: transaction}).subscribe(result => {
      console.log(result);
    });
  }

  finish(){
    this.dialogRef.close();
  }

  sendMail(email){
    this.btn_disabled = true;
    this.ticketDialogService.getEmailsCC().subscribe(emails => {
      console.log(emails);
      let bodyData = {
        to: email,
        subject: 'CNCI: Pago aprobado',
        message: this.buildBody(this.ticket),
        nameTo: this.ticket.short_name,
        nameFrom: 'CNCI',
        image: 0,
        logo: this.business_id == 3 ? 'logocnci.jpg' : 'logocnci_propios.jpg',
        who: 'studentportal',
        recipients: JSON.stringify(emails)
        /*recipients: JSON.stringify([{
          email: 'opr032094@gmail.com',
          name: 'Oscar'
        },
        {
        email: 'oscarperez_20@outlook.com',
        name: 'Oscar'
        }])*/
      }

      this.ticketDialogService.sendMail(bodyData).subscribe(result => {
        //console.log(result);
        this.btn_disabled = false;
        if(!result['error']){
          this.toastr.success("Correo de confirmación enviado exitosamente");
        }else{
          this.toastr.error("Ocurrió un error al enviar el Correo")
        }
      });
    });
  }

  buildBody(ticket){
    return "<table align='center' width='650px'>" + 
    "<tr><td colspan='4'><img src='cid:logocnci' style='display: block; margin-left: auto; margin-right: auto; width: 60%'/></td></tr>" + 
    "<tr><td colspan='4'><img src='cid:line'/></td></tr>" + 
    "<tr><td width='100%' colspan='4' align='center'><b>FAVOR DE NO RESPONDER A ESTE MENSAJE.</b></td></tr>" + 
    "<tr><td width='100%' colspan='4' align='center'>Este mensaje es generado por un servicio automatizado de respuestas.</tr>" + 
    "<tr><td width='100%' colspan='4' align='center'>Mensajes enviados a este buzón no serán recibidos.</td></tr>" + 
    "<tr><td colspan='4'><img src='cid:line' /></td></tr>" + 
    "<br>" + 
    "<tr><td width = '50%'><img src='cid:circle'/></td><td width = '50%'><div width='50%'><p>" + 
        "<h3 style = 'font-size: 20px; color: #003CA6;'>Pago exitoso.</h3>" + 
        "Numero de orden: <b>" + ticket.order +"</b><br/>" + 
        "Fecha: <b>" + ticket.date +"</b><br/>" + 
        "Nombre del estudiante: <b>" + ticket.username + "</b><br/>" + 
        "Matricula;  <b>" + ticket.registration + "</b> <br/>" + 
        "Programa: <b>" + ticket.plan + "</b><br/>" + 
        "Concepto: <b>" + ticket.concept_desc + "</b><br/>" + 
        "Monto: <b>" + ticket.amount + "MXN</b></p></div></td></tr>" + 
    "</tr>" + 
    "<tr><td colspan='4'><img src='cid:msg'/></td></tr>" + 
    "<tr><td colspan='4'></td></tr></table>"
  }

}
